<template>
  <div class="weeklyAboutContainer w-100">
    <MarketingRow
      :backgroundColor="weeklyAboutContent.backgroundColor"
      :body="weeklyAboutContent.body"
      :noAssetBackground="weeklyAboutContent.noAssetBackground"
      :textSide="weeklyAboutContent.textSide"
      :title="weeklyAboutContent.title"
      :titleType="weeklyAboutContent.titleType"
    >
      <template v-slot:marketingContent>
        <BImgLazy
          :alt="weeklyAboutContent.title.join(' ')"
          :class="{ overflowImage: weeklyAboutContent.overflowImage, 'contain': weeklyAboutContent.containImage }"
          :src="!isMobile ? weeklyAboutContent.imageUrlDesktop : weeklyAboutContent.imageUrlMobile"
        />
      </template>
    </MarketingRow>
    <VerticalIconMessage :messages="weeklyTripleIconMessages" />
    <MarketplaceDescription
      :body="weeklyDescription.body"
      :darkButtonLink="weeklyDescription.darkButtonLink"
      :darkButtonText="weeklyDescription.darkButtonText"
      :defaultButtonLink="weeklyDescription.defaultButtonLink"
      :defaultButtonText="weeklyDescription.defaultButtonText"
      :desktopImage="weeklyDescription.desktopImage"
      :mobileImage="weeklyDescription.mobileImage"
      :title="weeklyDescription.title"
    />
    <div class="bg-gradient-light-gray py-3">
      <MarketingRow
        :backgroundColor="ourRates.backgroundColor"
        :body="ourRates.body"
        :noAssetBackground="ourRates.noAssetBackground"
        :textSide="ourRates.textSide"
        :title="ourRates.title"
        :titleType="ourRates.titleType"
      >
        <template v-slot:marketingContent>
          <BImgLazy
            :alt="ourRates.title.join(' ')"
            :class="{ overflowImage: ourRates.overflowImage, 'contain': ourRates.containImage }"
            :src="!isMobile ? ourRates.imageUrlDesktop : ourRates.imageUrlMobile"
          />
        </template>
      </MarketingRow>
      <PricesGridRow
        :backgroundColor="weeklyFees.backgroundColor"
        :bodyText="weeklyFees.bodyText"
        :hasBorderTop="weeklyFees.hasBorderTop"
        :priceSections="weeklyFees.priceSections"
        :showSubmitButton="weeklyFees.showSubmitButton"
        :smallTitle="weeklyFees.smallTitle"
        :title="weeklyFees.title"
      />
    </div>
  </div>
</template>

<script>
import { BImgLazy } from 'bootstrap-vue';
import VerticalIconMessage from './VerticalIconMessage.vue';
import MarketplaceDescription from './MarketplaceDescription.vue';
import PricesGridRow from './PricesGridRow.vue';
import MarketingRow from '../../homepage/components/MarketingRow.vue';
import { weeklyAboutContent, weeklyDescription, weeklyFees, weeklyTripleIconMessages } from '../constants/weeklyConstants';
import { ourRates } from '../constants/singleMarketplaceConstants';
import { baseIsMobile } from '../../marketplaces/mixins';

export default {
  name: 'WeeklyAbout',
  components: {
    BImgLazy,
    MarketplaceDescription,
    MarketingRow,
    PricesGridRow,
    VerticalIconMessage,
  },
  mixins: [baseIsMobile],
  data() {
    return {
      weeklyAboutContent,
      weeklyDescription,
      weeklyFees,
      weeklyTripleIconMessages,
      ourRates
    };
  }
};
</script>
